import Header from "../components/Header";
import Footer from "../components/Footer";

export default function InternationalNRI() {
  return (
    <>
      <Header />

      {/* ===== HERO SECTION ===== */}
      <section
        className="about-hero"
        style={{
          backgroundImage: "url('/assets/img/international-nriservice.jpg')",
        }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>International & NRI Services</h1>
          <p>
            Expert FEMA, RBI, Cross-Border Tax & Global Compliance Solutions.
          </p>
        </div>
      </section>

      {/* ===== INTRO TEXT ===== */}
      <section className="nri-services">
        {/* <div className="container"> */}
          <h2>International & NRI Services</h2>
          <p className="service-text">
            In an increasingly globalised economy, individuals and businesses
            frequently engage in cross-border transactions, overseas
            investments, foreign remittances, and multi-jurisdictional tax
            matters. Navigating India’s foreign exchange regulations, tax laws,
            and compliance frameworks requires specialised expertise.
            <br />
            <br />
            At <strong>S D P M & Co.</strong>, we offer comprehensive
            International & NRI Advisory Services, helping NRIs, expatriates,
            and foreign investors manage finances with accuracy, tax efficiency,
            and full compliance with FEMA, RBI, and global tax frameworks.
          </p>

          {/* ===== GRID SECTION ===== */}
          <div className="container bf-main">
            {/* 1. FEMA & RBI */}
            <div className="bf-card">
              <h3>🌏 FEMA & RBI Compliances</h3>
              <p>
                End-to-end FEMA advisory for inbound & outbound transactions,
                RBI reporting (FC-GPR, FC-TRS, SMF), investment structure
                planning, transfer of shares, ECB compliance and documentation
                for capital account transactions.
              </p>
            </div>

            {/* 2. ODI / FDI */}
            <div className="bf-card">
              <h3>✈️ ODI / FDI Advisory</h3>
              <p>
                Advisory on setting up subsidiaries or joint ventures abroad,
                capitalisation of receivables, calculation of financial
                commitments, filing FLA/ODI forms, sectoral cap analysis, inward
                remittance reporting, FC-GPR/FC-TRS filings and compliance for
                foreign investments.
              </p>
            </div>

            {/* 3. Cross Border Tax */}
            <div className="bf-card">
              <h3>💼 Cross-Border Tax Planning</h3>
              <p>
                Tax residency determination, DTAA interpretation, tax credit
                mechanism, withholding tax compliance, PE analysis and global
                income structuring for expatriates, NRIs and multinational
                businesses.
              </p>
            </div>

            {/* 4. NRI Taxation */}
            <div className="bf-card">
              <h3>🏠 NRI Taxation & Investment Advisory</h3>
              <p>
                ITR filing for NRIs/OCI/PIO, property capital gains planning,
                lower TDS certificates, DTAA tax relief, scrutiny handling,
                repatriation planning (15CA/15CB), and NRI investment advisory
                for property, shares and inherited assets.
              </p>
            </div>

            {/* 5. Transfer Pricing */}
            <div className="bf-card">
              <h3>📊 Transfer Pricing Planning & Benchmarking</h3>
              <p>
                Transfer Pricing documentation (Local File & Master File),
                benchmarking studies, APA support, 3CEB certification, cost
                sharing arrangements and litigation support for cross-border
                related-party transactions.
              </p>
            </div>

            {/* 6. Global Compliance */}
            <div className="bf-card">
              <h3>🌐 International Tax & Regulatory Support</h3>
              <p>
                Advisory for foreign companies operating in India, branch office
                & subsidiary compliance, global tax structuring, regulatory
                filings and complete support for cross-jurisdiction operations.
              </p>
            </div>
          </div>
        {/* </div> */}
      </section>

      {/* ===== WHY CHOOSE US ===== */}
      {/* <section className="nri-highlight">
        <div className="container">
          <h2>Why Choose Us?</h2>
          <ul>
            <li>Strong expertise in FEMA, RBI, DTAA & International Tax Laws</li>
            <li>End-to-end advisory — planning, documentation & regulatory filings</li>
            <li>Dedicated NRI desk for taxation, property & investment advisory</li>
            <li>Global experience with NRIs across USA, UK, UAE, Australia & Canada</li>
            <li>Confidential, compliant & strategic advisory approach</li>
            <li>Timely filings with zero delays & precise documentation</li>
          </ul>
        </div>
      </section> */}

      {/* ===== FINAL SECTION ===== */}
      {/* <section className="bf-cta py-5 text-white text-center">
  <div className="container">
    <h2 className="fw-bold mb-3">Expand Globally With Confidence</h2>
    <p className="mb-3">
      Whether you are an NRI managing assets in India, a business planning overseas
      expansion, or an entity receiving foreign investment — we help you stay
      compliant, tax-efficient, and globally aligned.
    </p>

    <Link
      to="/contactus"
      className="apply-btn"
      style={{
        backgroundColor: "#65ad4b",
        color: "#fff",
        borderRadius: "8px",
      }}
      onClick={() => window.scrollTo({ top: 0 })}
    >
      Contact Us
    </Link>
  </div>
</section> */}

      <Footer />
    </>
  );
}
